import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient, } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MatPageable, PageableResponse } from '@core/table/mat-table';
import { buildQueryString } from '@shared/util/util';
import { DomainCacheService } from './domain-cache.service';


const baseRef = 'tipo-entidade';
const baseRefSubTipo = 'sub-tipo-entidade';
const cargoTipo = 'cargo-tipo-entidade';

const route = {
  listar: `${baseRef}`,
  listarSubTipos: `${baseRefSubTipo}`,
  listarSubTiposFiltrados: `${baseRefSubTipo}/filtrar`,
  listarSubTiposEntidade: (idTipoEntidade: number) => `${baseRefSubTipo}/subtipo/${idTipoEntidade}/combo`,
  listarEspecificacoes: `${baseRefSubTipo}/tipo-orgao`,
  listarEspecificacoesPorSubTipo: (idSubTipo: number) => `${baseRefSubTipo}/tiposSubTipo/${idSubTipo}/combo`,
  salvarSubtipoEntidade: `${baseRefSubTipo}/salvar`,
  editarSubtipoEntidade: `${baseRefSubTipo}/salvar`,
  subTipoEntidadeId: (id: number) => `${baseRefSubTipo}/${id}`,
  subTipoEntidadeAtivar: (idSubTipo: number) => `${baseRefSubTipo}/${idSubTipo}/reativar`,
  subTipoEntidadeInativar: (idSubTipo: number) => `${baseRefSubTipo}/${idSubTipo}/inativar`,
  listarSubTiposFiltradosSort: `${baseRefSubTipo}/filtrar`
};

@Injectable({
  providedIn: 'root'
})
export class TipoEntidadeService {

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private domainCache: DomainCacheService
  ) { }

  listar(): Observable<any> {
    return this.domainCache.getOrLoad(route.listar, () =>
      this.apiService.get<any>(`${route.listar}`, undefined, undefined, true)
    );
  }

  listarPorTipoEnum(): Observable<any> {
    return this.listar();
  }

  listarSubTipos(tipoEntidade: number[] | null): Observable<any> {
    const queryString = buildQueryString(Object.fromEntries(Object.entries({tipoEntidade}).filter(([_, value]) => value !== null && value !== undefined)));
    const fullUrl = `${route.listarSubTipos}?${queryString}`;
    return this.apiService.get<any>(fullUrl);
  }

  listarSubTiposEntidade(id: number): Observable<any> {
    return this.apiService.get<any>(route.listarSubTiposEntidade(id));
  }


  listarEspecificacoes(): Observable<any> {
    return this.apiService.get<any>(`${route.listarEspecificacoes}`);
  }

  listarEspecificacoesPorSubTipo(idSubTipo: number): Observable<any> {
    return this.apiService.get<any>(`${route.listarEspecificacoesPorSubTipo(idSubTipo)}`);
  }

  salvarSubtipoEntidade(data: any): Observable<any> {
    return this.apiService.post<any>(route.salvarSubtipoEntidade, data).pipe(
      tap(() => this.domainCache.invalidate(route.listar))
    );
  }

  editarSubtipoEntidade(data: any): Observable<any> {
    return this.apiService.post<any>(route.editarSubtipoEntidade, data).pipe(
      tap(() => this.domainCache.invalidate(route.listar))
    );
  }

  buscarSubTipoEntidadePorId(id: number): Observable<any> {
    return this.apiService.get<any>(`${route.subTipoEntidadeId(id)}`);
  }

  ativarSubTipoEntidade(idSubTipo: number): Observable<any> {
    return this.apiService.post<any>(route.subTipoEntidadeAtivar(idSubTipo), {}).pipe(
      tap(() => this.domainCache.invalidate(route.listar))
    );
  }

  inativarSubTipoEntidade(idSubTipo: number): Observable<any> {
    return this.apiService.post<any>(route.subTipoEntidadeInativar(idSubTipo), {}).pipe(
      tap(() => this.domainCache.invalidate(route.listar))
    );
  }

  consultarSort(filtro: any, page: MatPageable, params: any): Observable<any> {
   const queryString = buildQueryString({...params});
    const fullUrl = `${route.listarSubTiposFiltrados}${page.query}${queryString}`;
    return this.apiService.post<PageableResponse<any>>(
      fullUrl,
      this.apiService.removeNullPropertys(filtro)
    );
  };
   consultar(filtro: any, page: MatPageable) {
    return this.apiService.post<PageableResponse<any>>(`${route.listarSubTiposFiltrados}${page.query}`, this.apiService.removeNullPropertys(filtro));
  }

  }
